<template>
  <div>
    <div class="d-flex flex-row p-2" :class="{'justify-content-lg-end': id === 'target-level-2'}">
      <div>
        <img class="membership_image" :src="levelIcon" :alt="level?.name">
      </div>
      <div>
        <div :style="{ color: colorCode }" :class="{ 'membership_title': true, 'font-weight-bolder': hasLevels }">
          {{ level?.name }}
        </div>
        <div :class="{ 'font-weight-bolder': hasLevels }">
          {{ level?.rewards_multiplier }} points per $1 spent
        </div>
        <div>
          <div v-if="nextLevel">
            ${{ currencyFormat(level?.amount) }} - ${{ nextLevel ? currencyFormat(nextLevel?.amount-1) : '+' }} in purchase
          </div>
          <div v-else>
            ${{ currencyFormat(level?.amount) }}+ in purchase
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {currencyFormat} from "@core/helpers/configHelper";

export default {
  name: "MembershipCard",
  props: ['id', 'level', 'nextLevel'],
  data() {
    return {
      currencyFormat
    }
  },
  computed: {
    levelIcon() {
      return this.level?.media[0] ? this.level?.media[0].original_url : `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    },
    hasLevels() {
      return this.allLevels && this.allLevels?.length
    },
    colorCode() {
      return '#' + this.level?.title_color_code
    }
  }
}
</script>

<style scoped>
.membership_image {
  max-width: 70px;
  padding: 5px;
}

.membership_title {
  font-size: 20px;
}
</style>
